export const CALENDLY_URLS = {
  GENERAL_SUPPORT: "https://calendly.com/careteam-elayne/here-to-help",
  ESTATE_SETTLEMENT_QUOTE:
    "https://calendly.com/d/cvnj-xjc-p9g/meet-with-your-elayne-estate-expert",
  ATTORNEY_ONBOARDING: "https://calendly.com/careteam-elayne/onboarding",
  ATTORNEY_SUPPORT: "https://calendly.com/careteam-elayne/attorney-support",
  ASSET_SEARCH_SETUP:
    "https://calendly.com/d/cvxg-q2b-98q/elayne-asset-search-set-up",
} as const;

export const ESTATE_EXPERT_BOOKING_SOURCE = "estate_expert_call";
export const ASSET_SEARCH_BOOKING_SOURCE = "asset_search_setup";
